<div class="relatorio-container">
    <div class="toolbar no-print">
        <div class="flex justify-content-between align-items-center">
            <div>
                <button pButton pRipple type="button" label="Voltar" icon="pi pi-arrow-left"
                    class="p-button-secondary mr-2" (click)="voltar()"></button>
            </div>
            <div class="flex align-items-center">
                <p-checkbox [(ngModel)]="quebraPaginaPorEstacao" [binary]="true"
                    label="Quebrar página por estação" class="mr-3"></p-checkbox>
                <button pButton pRipple type="button" label="Exportar Excel" icon="pi pi-file-excel"
                    class="p-button-success mr-2" (click)="exportarExcel()" [disabled]="loading || data.length === 0"></button>
                <button pButton pRipple type="button" label="Exportar PDF" icon="pi pi-file-pdf"
                    class="p-button-danger" (click)="exportarPDF()" [disabled]="loading || data.length === 0"></button>
            </div>
        </div>
    </div>

    <div *ngIf="loading" class="loading-container no-print">
        <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="8"
            fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
        <p>Carregando dados do relatório...</p>
    </div>

    <div class="relatorio-content" *ngIf="!loading">
        <header class="relatorio-header">
            <div class="header-top">
                <div class="logo-area">
                    <h1>MITSAT</h1>
                    <span class="subtitulo">Sistema de Monitoramento</span>
                </div>
                <div class="info-geracao">
                    <span>Gerado em: {{ dataGeracao }}</span>
                </div>
            </div>
            <div class="header-titulo">
                <h2>Relatório de Resumo de Eventos</h2>
            </div>
            <div class="header-filtros">
                <div class="filtro-item">
                    <strong>Período:</strong> {{ periodoFormatado }}
                </div>
                <div class="filtro-item">
                    <strong>Filtros:</strong> {{ getDescricaoFiltros() }}
                </div>
                <div class="filtro-item">
                    <strong>Total de Estações:</strong> {{ data.length }}
                </div>
            </div>
        </header>

        <main class="relatorio-body">
            <section *ngFor="let estacao of data; let isLast = last"
                class="estacao-section" [class.page-break]="quebraPaginaPorEstacao && !isLast">

                <div class="estacao-header">
                    <h3>{{ estacao.descricao }}</h3>
                </div>

                <table class="tabela-eventos">
                    <thead>
                        <tr>
                            <th class="col-data">Data</th>
                            <th class="col-eventos">Eventos</th>
                            <th class="col-monitoramentos">Monitoramentos</th>
                            <th class="col-disponibilidade">Disp.</th>
                            <th class="col-atraso">Atraso</th>
                            <th class="col-integracao">Integração</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let col of columns">
                            <td class="col-data">
                                <div class="data-info">
                                    <span class="dia-semana">{{ col.diaSemana }}</span>
                                    <span class="data-formatada">{{ col.dataFormatada }}</span>
                                </div>
                            </td>
                            <td class="col-eventos">
                                <div class="eventos-lista">
                                    <ng-container *ngIf="getEventosIrregulares(estacao, col.data_resumo).length > 0; else semEventos">
                                        <span *ngFor="let evento of getEventosIrregulares(estacao, col.data_resumo)"
                                            class="evento-texto">
                                            {{ evento.tipo_evento?.descricao }}
                                        </span>
                                    </ng-container>
                                    <ng-template #semEventos>
                                        <span class="sem-dados">-</span>
                                    </ng-template>
                                </div>
                            </td>
                            <td class="col-monitoramentos">
                                <div class="monitoramentos-lista">
                                    <ng-container *ngIf="getMonitoramentosIconesNaData(estacao, col.data_resumo).length > 0; else semMonitoramentos">
                                        <span *ngFor="let cat of getMonitoramentosIconesNaData(estacao, col.data_resumo)"
                                            class="monitoramento-texto">
                                            {{ cat.label }}
                                        </span>
                                    </ng-container>
                                    <ng-template #semMonitoramentos>
                                        <span class="sem-dados">-</span>
                                    </ng-template>
                                </div>
                            </td>
                            <td class="col-disponibilidade">
                                <ng-container *ngFor="let evento of getEventosNaData(estacao, col.data_resumo)">
                                    <span *ngIf="evento.tipo_evento_id === 7">
                                        {{ evento.disponibilidade || '-' }}
                                    </span>
                                </ng-container>
                                <span *ngIf="!hasEventosNaData(estacao, col.data_resumo)">-</span>
                            </td>
                            <td class="col-atraso">
                                <ng-container *ngFor="let evento of getEventosNaData(estacao, col.data_resumo)">
                                    <span *ngIf="evento.tipo_evento_id === 7">
                                        {{ evento.atraso_medio_integracao || 'N/A' }}
                                    </span>
                                </ng-container>
                                <span *ngIf="!hasEventosNaData(estacao, col.data_resumo)">-</span>
                            </td>
                            <td class="col-integracao">
                                <ng-container *ngFor="let evento of getEventosNaData(estacao, col.data_resumo)">
                                    <strong *ngIf="evento.tipo_evento_id === 7">
                                        {{ evento.percentual_integracao || '-' }}
                                    </strong>
                                </ng-container>
                                <span *ngIf="!hasEventosNaData(estacao, col.data_resumo)">-</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </section>
        </main>

        <footer class="relatorio-footer">
            <div class="rodape-info">
                <span>MITSAT - Sistema de Monitoramento | {{ dataGeracao }}</span>
            </div>
        </footer>
    </div>
</div>
